export class ValidatorUtils {
  isEmptyOrNull(value: any): boolean {
    if (value == null || value === '' || value.length < 0 || value < 0)
      return true;
    return false;
  }

  isValidCPF(cpf: string): boolean {
    if (typeof cpf !== 'string') return false;

    cpf = cpf.replace(/[\s.-]*/gim, '');
    if (
      !cpf ||
      cpf.length !== 11 ||
      cpf === '00000000000' ||
      cpf === '11111111111' ||
      cpf === '22222222222' ||
      cpf === '33333333333' ||
      cpf === '44444444444' ||
      cpf === '55555555555' ||
      cpf === '66666666666' ||
      cpf === '77777777777' ||
      cpf === '88888888888' ||
      cpf === '99999999999'
    ) {
      return false;
    }

    let sum = 0;
    let remainder;
    for (let i = 1; i <= 9; i++)
      sum = sum + parseInt(cpf.substring(i - 1, i)) * (11 - i);

    remainder = (sum * 10) % 11;
    if (remainder === 10 || remainder === 11) remainder = 0;
    if (remainder !== parseInt(cpf.substring(9, 10))) return false;

    sum = 0;
    for (let i = 1; i <= 10; i++)
      sum = sum + parseInt(cpf.substring(i - 1, i)) * (12 - i);

    remainder = (sum * 10) % 11;
    if (remainder === 10 || remainder === 11) remainder = 0;
    if (remainder !== parseInt(cpf.substring(10, 11))) return false;

    return true;
  }

  isValidEmail(email: string): boolean {
    const re = /\S+@\S+\.\S+/;
    return !re.test(email);
  }

  convertMoney(money: number) {
    const formatter = new Intl.NumberFormat('pt-BR', {
      style: 'currency',
      currency: 'BRL',
    });
    return formatter.format(money);
  }

  convertDateStringToApi(data: string) {
    if (data !== null) {
      const aux_date = data.split('/');
      const aux_data = [aux_date[2], aux_date[1], aux_date[0]].join('-');
      return `${aux_data}T00:00:00`;
    } else {
      return null;
    }
  }

  convertDateApiToString(data: string) {
    if (data !== null) {
      const remove = data.split('T');
      const aux_date = remove[0].split('-');
      const aux_data = [aux_date[2], aux_date[1], aux_date[0]].join('/');
      return aux_data;
    } else {
      return null;
    }
  }
}
